// Custom plugin to set the grid area (chart plot) background color
const chartAreaBackground = {
  id: "chartAreaBackground",
  beforeDraw: (chart) => {
    const ctx = chart.ctx;
    const chartArea = chart.chartArea;
    if (!chartArea) return; // Prevents errors

    ctx.save();
    ctx.fillStyle = "#0d6efd"; // background to match icon color
    ctx.fillRect(
      chartArea.left,
      chartArea.top,
      chartArea.right - chartArea.left,
      chartArea.bottom - chartArea.top,
    );
    ctx.restore();
  },
};

const config = {
  /**
   * Helps intellisense give us chart options
   * @type {import("chart.js").ChartData}
   */
  data: {
    labels: [],
    datasets: [
      {
        type: 'line',
        label: 'Profit and Loss',
        data: [],
        fill: false,
        borderColor: "#fff",
        tension: 0.1, // line curve
        borderWidth: 2, // Line thickness
        pointRadius: 3, // Size of each point
        pointHoverRadius: 5, // Size when hovered
      },
      {
        type: 'bar',
        label: 'Max Daily Balance',
        data: [],
        fill: false,
        borderColor: 'rgba(90, 184, 73, 0.8)',
        backgroundColor: 'rgba(90, 184, 73, 0.8)',
        tension: 0.1, // line curve
        borderWidth: 2, // Line thickness
        pointRadius: 3, // Size of each point
        pointHoverRadius: 5, // Size when hovered
      }
    ],
  },
  /**
   * Helps intellisense give us chart options
   * @type {import("chart.js").ChartOptions}
   */
  options: {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        offset: true,
        ticks: {
          padding: 15,
          font: {
            size: 14,
            weight: "bold",
          },
        },
        grid: {
          display: false,
          drawTicks: false, // Prevents grid lines from extending toward labels
          borderWidth: 0, // Removes extra border
          drawBorder: false, // Hide x-axis border line
        },
      },
      y: {
        offset: true,
        ticks: {
          padding: 10,
          callback: function (value, index, values) {
            return "$" + value.toLocaleString(); // Adds a "$" prefix to each label
          },
          font: {
            size: 14,
            weight: "bold",
          },
        },
        grid: {
          drawTicks: false, // Prevents grid lines from extending toward labels
          borderWidth: 0, // Removes extra border
          color: ({tick}) => tick.value === 0 ?  'rgba(242, 242, 242, 0.8)' : "rgba(200, 200, 200, 0.3)",
          drawBorder: false, // Hide y-axis border line
          lineWidth: ({ tick }) => tick.value === 0 ? 3 : 1,
        },
      },
    },

    plugins: {
      tooltip: {
        padding: 10,
        boxPadding: 5,
        caretPadding: 15,
      },
      legend: {
        display: true,
        position: "bottom", // Moves legend below the chart
        align: "center", // Ensures the legend is centered
        labels: {
          boxWidth: 20, // Controls the box size next to each label
          padding: 15, // Adds spacing between legend items
          font: {
            size: 14,
            weight: "bold",
          },
        }
      },
      datalabels: {
        display: false,
      },
      title: {
        display: true,
        text: "Daily Profit",
        padding: { top: 15, bottom: 15 },
        font: {
          size: 20,
        },
      },
    },
  },
  chartAreaBackground,
};

export default config;
